<template>
  <component
    :is="tag"
    :href="url"
    :target="target"
    :class="buttonClassList"
    :disabled="disabled"
    @click="clickHandler"
  >
    <span
      class="absolute -inset-1.5 opacity-0 group-focus:opacity-100 border-2 border-grey-900 border-solid rounded-lg transition-opacity duration-200 ease-in-out pointer-events-none"
    ></span>
    <Sprite
      v-if="iconId !== null && !iconReversed"
      :id="iconId"
      :class="defaultIconClassList"
    />
    <span
      :class="[
        'u-body-md font-bold border-b-2 border-solid border-transparent group-hover:border-current transition-colors duration-200 ease-in-out',
        textColour,
        labelClassList,
      ]"
      v-html="label"
    >
    </span>
    <Sprite
      v-if="iconId !== null && iconReversed"
      :id="iconId"
      :class="defaultIconClassList"
    />
  </component>
</template>

<script>
import Sprite from './Sprite';

export default {
  components: {
    Sprite,
  },
  props: {
    buttonType: {
      type: String,
      validator(value) {
        return ['primary', 'secondary', 'third'].includes(value);
      },
      default: 'primary',
    },
    tag: {
      type: String,
      validator(value) {
        return ['button', 'a'].includes(value);
      },
      default: 'a',
    },
    label: {
      type: String,
      required: true,
    },
    url: {
      type: String,
    },
    target: {
      type: String,
      default: '_self',
      validator(value) {
        return ['_self', '_blank'].includes(value);
      },
    },
    clickFunction: {
      type: Function,
      default: null,
    },
    textColour: {
      type: String,
      default: 'text-grey-900',
    },
    labelClassList: {
      type: String,
      default: null,
    },
    iconId: {
      type: String,
      default: null,
    },
    iconClassList: {
      type: String,
      default: null,
    },
    iconReversed: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    defaultIconClassList() {
      if (this.iconClassList) {
        return this.iconClassList;
      } else if (this.iconReversed) {
        return 'w-6 h-6 ml-2';
      } else {
        return 'w-6 h-6 mr-2';
      }
    },
    buttonClassList() {
      let classList;
      switch (this.buttonType) {
        case 'primary':
          classList =
            'inline-flex relative flex-nowrap items-center group focus:outline-none bg-primary-400 hover:bg-white text-grey-900 rounded-lg h-12 px-2 xs:px-4 py-3 border-2 border-solid border-primary-400 transition-colors duration-200 ease-in-out disabled:pointer-events-none disabled:bg-grey-200 disabled:text-grey-600 disabled:border-0 disabled:cursor-not-allowed';
          break;
        case 'secondary':
          classList =
            'inline-flex relative flex-nowrap items-center group focus:outline-none rounded-lg h-12 px-2 xs:px-4 py-3 border border-solid transition duration-200 ease-in-out bg-white border-primary hover:shadow-button-secondary disabled:pointer-events-none disabled:border-grey-200 disabled:text-grey-600 disabled:cursor-not-allowed';
          break;
        case 'third':
          classList =
            'inline-flex relative flex-nowrap items-center group focus:outline-none rounded-4xl h-12 px-4 xs:px-4 py-3 border border-solid border-grey-400 hover:shadow-button-third hover:border-2 transition duration-200 ease-in-out';
          break;
      }
      return classList;
    },
  },
  methods: {
    clickHandler(e) {
      if (this.clickFunction !== null) this.clickFunction(e);
    },
  },
};
</script>
